<template>
    <md-container>
        <!-- 左侧菜单 -->
        <md-aside class="menu-aside">
            <leftSidebar :isCollapse="isCollapse"></leftSidebar>
        </md-aside>

        <!-- 右侧头部与内容 -->
        <md-container class='layout-right' :class="{'layout-right-col': isCollapse}">
            <md-header class="md-header">
                <Header @handleCollapse="handleCollapse"></header>
            </md-header>
            <tags-nav/>
            <md-main class="layout-main" :class="{'is-home': $route.path === '/gsc'}">
                <keep-alive :include="tags.map(item => item.name)">
                    <router-view></router-view>
                </keep-alive>
            </md-main>
        </md-container>
        <!--弹窗-->
        <div v-if="tipsShow" class="tips-bg">
            <div class="btn-layout">
                <div class="item" @click="switchSystem"></div>
                <div class="title" @click="switchSystem">{{$t('newHome.t3')}}</div>
                <div class="item item2"></div>
                <div class="title">G5000</div>
                <div class="other"></div>
                <div class="bg"></div>
                <md-icon class="icon-right" name="md-icon-a-Rightarrow"></md-icon>
                <span class="btn-tips">{{$t('newHome.t6')}}</span>
                <md-button class="close-btn" type="primary" @click="updateFlag">{{$t('newHome.t5')}}</md-button>
            </div>
        </div>
        <notice-dialog></notice-dialog>
    </md-container>
</template>
<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import tagsNav from '@/components/core/tags_nav';
import noticeDialog from '@/modules/globalprotal//views/sys/noticeDialog.vue';
import Header from './header.vue';
import leftSidebar from './leftSidebar.vue';

export default {
    components: {
        Header,
        leftSidebar,
        tagsNav,
        noticeDialog,
    },
    computed: {
        ...mapGetters(['tags']),
    },
    watch: {
        tipsShow(val) {
            if (val) {
                const hideFun = () => {
                    const dom = document.getElementById('FeedBackTabsMove');
                    if (dom) {
                        dom.style.display = 'none';
                        clearInterval(this.timeId);
                    }
                };
                this.timeId = setInterval(hideFun, 100);
            } else {
                document.getElementById('FeedBackTabsMove').style.display = 'block';
            }
        },
    },
    data() {
        return {
            timeId: null,
            isCollapse: false,
            // 用于子组件注入；
            provideObj: {
                isCollapse: false,
            },
            tipsShow: false,
        };
    },
    methods: {
        handleCollapse() {
            this.isCollapse = !this.isCollapse;
            this.provideObj.isCollapse = this.isCollapse;
        },
        switchSystem() {
            this.updateFlag();
            const dom = document.getElementById('FeedBackTabsMove');
            dom.style.display = 'block';
            dom.querySelector('.feedback-switchover-old').click();
        },
        updateFlag() {
            this.tipsShow = false;
            this.getTipsFlag(JSON.stringify({ list: Date.now() }));
        },
        getTipsFlag(content) {
            axios.post('/gscapp/homepage/vendorIndividuation', {
                vendorCode: this.vendorCode,
                type: 'gscIntTipsFlag',
                content,
            })
                .then((res) => {
                    const { datas } = res.data.data;
                    if (datas) {
                        this.tipsShow = !datas.content.list;
                    }
                });
        },
    },
    mounted() {
        this.getTipsFlag();
    },
};
</script>
<style lang="less" scoped>
@import url("../../../../styles/layout.less");
@import url("../../../../styles/vars.less");
// 左侧菜单通过fixed固定, 右侧可以滚动
.menu-aside {
    position: fixed;
    left: 0px;
    z-index: 1000;
    width: auto !important;
    height: 100vh;
    overflow-x: hidden;
    box-shadow: 2px 0px 6px 0px rgba(0,21,41,0.06);
    &::-webkit-scrollbar {
        width: 4px;
        height: 2px;
    }
}
.layout-right {
    // transition: all 0.1s ease-in;
    margin-left: @leftSidebar-width;
    // overflow-y: auto;
    height: 100vh;
    .md-header {
        height: @header-height !important;
        box-shadow: 0px 1px 0px 0px #F1F1F1;
        background-color: #fff;
        z-index: 1;
    }

    .tags-nav {
        height: @tagnavs-height;
    }

    .layout-main {
        background-color: @content-bg-color;
        padding: 12px;
        // overflow-y: hidden;
        // min-height: calc(100vh - @header-height - @tagnavs-height);
        overflow-x: hidden; // 右侧模块整个滚动，去掉可以设置只内容区域滚动
        &.is-home {
            overflow-x: auto; // 首页可横向滚动
        }
    }
}
.layout-right-col {
    margin-left: @leftSidebar-width-col;
}
.tips-bg {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .5);
    z-index: 999999999999999;
    .btn-layout {
        position: absolute;
        right: 10px;
        bottom: 100px;
        width: 64px;
        height: 182px;
        box-shadow: 0 5px 9px 0 rgba(0, 0, 0, .2);
        border-radius: 10px;
        text-align: center;
        font-size: 22px;
        background: #FFF;
        font-family: iconfont-feedback!important;
        .item {
            margin-top: 10px;
            line-height: 36px;
            color: rgb(0, 119, 255);
            cursor: pointer;
            &::before {
                content: "\E60F";
            }
        }
        .item2 {
            &::before {
                content: "\E602";
            }
        }
        .title {
            font-size: 12px;
            line-height: 14px;
            color: rgb(102, 102, 102);
            cursor: pointer;
        }
        .other {
            margin: 10px 0;
            font-size: 24px;
            line-height: 50px;
            color: #999;
            &::before {
                content: "\EB0B";
            }
        }
        .bg {
            position: absolute;
            right: 0;
            bottom: 0;
            width: 100%;
            height: 110px;
            background: rgba(0, 0, 0, .5);
            border-radius: 0 0 10px 10px;
        }
    }
    .icon-right {
        position: absolute;
        right: 80px;
        bottom: 110px;
        font-size: 80px;
        color: #FFF;
    }
    .btn-tips {
        position: absolute;
        right: 170px;
        bottom: 130px;
        line-height: 35px;
        padding: 0 20px;
        border-radius: 5px;
        color: #FFF;
        white-space: nowrap;
        font-size: 30px;
        font-weight: bold;
    }
    .close-btn {
        position: absolute;
        right: 200px;
        bottom: 60px;
    }
}
</style>
